
import { Tbl_formazioneEdit } from './tbl_formazioneEdit';
import { Tbl_formazioneList } from './tbl_formazioneList';
import { Tbl_formazioneShow } from './tbl_formazioneShow';
import { Tbl_formazioneCreate } from './tbl_formazioneCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_formazioneList,
    edit: Tbl_formazioneEdit,
    show: Tbl_formazioneShow,
    create: Tbl_formazioneCreate,
    icon: MapIcon
};
            